<template>
  <div class="block-hero" v-if="prod">
    <figure class="hero-image">
      <Image
        :filename="prod.images?.[0]?.filename"
        :context="prod"
        sizes="(max-width: 768px) 100vw, 60vw"
      />
    </figure>
    <div class="hero-body">
      <p class="hero-dates" v-if="prod.datestart">
        {{ formatDate(prod.datestart) }}
        <template v-if="prod.dateend">–<br>{{ formatDate(prod.dateend) }}</template>
      </p>
      <h2 class="hero-title">{{ prod.title }}</h2>
      <p class="hero-tagline" v-if="prod.tagline">{{ prod.tagline }}</p>
      <a v-if="prod.url" :href="pathName(prod.url)" class="hero-link">→</a>
    </div>
  </div>
</template>

<script setup>
import { useStore } from '@/KQL.js'

const props = defineProps(['block'])
const kql = useStore()

const prod = computed(() => {
  const id = props.block?.content?.page?.[0]
  if (!id) return null
  return pageFromPath(id, kql.pages)
})

const formatDate = (str) => {
  if (!str) return ''
  return new Intl.DateTimeFormat('fi', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(str))
}
</script>

<style scoped>
.block-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--offset);
  align-items: end;
}

.hero-image img {
  width: 100%;
  display: block;
}

.hero-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.hero-dates {
  font-size: 1rem;
  line-height: 1.3;
  opacity: 0.5;
  margin: 0;
}

.hero-title {
  font-size: clamp(2rem, 5vw, 4rem);
  line-height: 1.05;
  margin: 0;
}

.hero-tagline {
  max-width: 36em;
  line-height: 1.5;
  margin: 0;
}

.hero-link {
  align-self: flex-start;
  font-size: 1.5rem;
}

@media (max-width: 768px) {
  .block-hero { grid-template-columns: 1fr; }
}
</style>
